module.exports = __webpack_public_path__ + "static/angular-79ef6cf520106901e14289d17fc2efe1.jpg";